import { hexToRgba } from '../../../../utils/utils'

const headerPaddingBottom = '2.25rem'

export default (theme: any) => ({
    PrimaryHeader: {
        position: 'fixed',
        top: 0,
        right: 0,
        left: 0,
        height: `calc(${theme.constants.primaryNavigationShift} + ${headerPaddingBottom})`,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        zIndex: 1300,
        padding: `0 1.5rem ${headerPaddingBottom}`,
        background: theme.palette.lightGrey.gradient,
    },

    PrimaryHeaderStealthMode: {
        filter: 'grayscale(1)',
    },

    PrimaryHeaderNoFade: {
        padding: '0 1.5rem 0',
        height: theme.constants.primaryNavigationShift,
        background: theme.palette.lightGrey.main,
    },

    PrimaryHeaderTransparent: {
        [theme.breakpoints.down(theme.constants.formats.breakpoint)]: {
            background: 'transparent',
        },
    },

    PrimaryHeaderLogo: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flex: 1,
    },

    PrimaryHeaderLogoWhite: {
        [theme.breakpoints.down(theme.constants.formats.breakpoint)]: {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            flex: 1,
            color: '#ffffff',
        },
    },

    PrimaryHeaderLogoPrimary: {
        width: '2.5rem',
        height: '2.5rem',
        '& path:last-of-type': {
            fill: `linear-gradient(to right, ${hexToRgba(theme.palette.logo.main, 0.15)}, ${hexToRgba(
                theme.palette.logo.main,
                0.56
            )}, ${hexToRgba(theme.palette.logo.main, 0.89)})`,
        },
    },

    PrimaryHeaderLogoLogotypeContainer: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        paddingLeft: '1rem',
    },

    PrimaryHeaderLogoLogotype: {
        display: 'none',
        maxWidth: '9rem',
        width: '100%',
        [theme.breakpoints.up('lg')]: {
            display: 'flex',
            marginLeft: '1rem',
        },
    },

    PrimaryHeaderLogoDesktop: {
        display: 'none',
        [theme.breakpoints.up(theme.constants.formats.breakpoint)]: {
            display: 'flex',
            width: '2.5rem',
            height: '2.5rem',
        },
    },

    PrimaryHeaderLogoMobile: {
        transform: 'translateX(-1rem)',
        [theme.breakpoints.up(theme.constants.formats.breakpoint)]: {
            display: 'none',
        },
    },

    PrimaryHeaderLink: {
        display: 'flex',
        flex: 1,
        [theme.breakpoints.up(theme.constants.formats.breakpoint)]: {
            minWidth: '10rem',
            width: '100%',
        },
    },

    PrimaryHeaderLinkWithoutNavigation: {
        maxWidth: '15rem',
        background: 'transparent !important',
        // flex: 0,
    },

    PrimaryHeaderWithoutNavigation: {
        zIndex: '1000 !important',
    },

    PrimaryHeaderLinkDisable: {
        pointerEvents: 'none',
    },
})
